import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, Typography } from "@mui/material";
import EmptyAppointment from "assets/client-no-appointment.png";

const EmptyNextAppointment: React.FC = () => {
  const { t } = useTranslation(["dashboard"]);

  return (
    <Stack direction="column" spacing={0} mt={7} alignItems="center">
      <Box>
        <img src={EmptyAppointment} width={223} alt="Empty next appointment" />
      </Box>

      <Typography
        component="p"
        variant="body1"
        color="text.secondary"
        style={{ textAlign: "center", maxWidth: "241px" }}
      >
        {t("dashboard:parent.nextAppointment.empty")}
      </Typography>
    </Stack>
  );
};

export default EmptyNextAppointment;
